// "Due on Site" resolution + write helpers.
//
// Order of precedence:
//   1. jobs.due_on_site if the owner has explicitly overridden it
//   2. jobs.contract_value (which is snapshotted from bid.total at schedule time)
//   3. jobs.bid?.total if loaded — kept for safety though contract_value
//      should already mirror it
//   4. 0
import { supabase } from './supabase'

export function resolveDueOnSite(job) {
  if (!job) return 0
  if (job.due_on_site != null && job.due_on_site !== '') return Number(job.due_on_site)
  if (job.contract_value != null && job.contract_value !== '') return Number(job.contract_value)
  if (job.bid && job.bid.total != null) return Number(job.bid.total)
  return 0
}

// What the bid would charge — used as the "reference / use bid total" amount
// in the edit modal.
export function bidTotalForJob(job) {
  if (!job) return 0
  if (job.contract_value != null) return Number(job.contract_value)
  if (job.bid && job.bid.total != null) return Number(job.bid.total)
  return 0
}

// Persist a due_on_site override. Pass amount=null to clear (fall back to
// the bid total). Sets updated_by for audit.
export async function saveDueOnSite(jobId, { amount, notes, userId }) {
  const patch = {
    due_on_site: amount == null || amount === '' ? null : Number(amount),
    due_on_site_notes: notes ? String(notes) : null,
    updated_at: new Date().toISOString(),
    updated_by: userId || null,
  }
  return supabase.from('jobs').update(patch).eq('id', jobId)
}

export function fmtMoney(n) {
  const v = Number(n || 0)
  return '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
